import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOpnsenseComponent } from './simple-icons-opnsense.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOpnsenseComponent ],
    exports:      [ SimpleIconsOpnsenseComponent ],
    bootstrap:    []
})
export class SimpleIconsOpnsenseModule {}
